module.exports = __webpack_public_path__ + "img/mdh-logo.1915a336.png";